import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useSearchParams,
} from "react-router-dom";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
// import Form_Mech from "./pages/Form_Mech";
// import Form_BPCH from "./pages/Form_BPCH";
// import Form_FB from "./pages/Form_FB";
// import Form_FB_New from "./pages/Form_FB_New";
// import Form_Packaging from "./pages/Form_FB_V4";
import CookiesPage from "./features/fb/cookies/CookiesPage";
import ShampooPage from "./features/bpch/shampoo/ShampooPage";
import GenericCostingPage from "./shared/pages/GenericCostingPage";
import GenericCostingPage2 from "./shared/pages/GenericCostingPage2";
import PlasticsPage from "./features/mech/plastics/PlasticsPage";
import PlasticsPageCopy from "./features/mech/plastics - Copy/PlasticsPage";
import SheetmetalPage from "./features/mech/sheetmetal/SheetmetalPage";
import SheetmetalPageCopy from "./features/mech/sheetmetal - Copy/SheetmetalPage";
import CastingPage from "./features/mech/casting/CastingPage";
import ForgingPage from "./features/mech/forging/ForgingPage";
import GenericPlasticsCosting from "./features/mech/Generic_Plastics/GenericPlasticsCosting";
import PCBPage from "./features/ee/pcb/PCBPage";
import CorrugatedPage from "./features/packaging/corrugated/CorrugatedPage";
// import CorrugatedPage from "./features/packaging/corrugated - Copy/CorrugatedPage";
import GlassbottlesPage from "./features/packaging/GlassBottles/GlassbottlesPage";
import CommoditySelectionPage from "./pages/CommoditySelectionPage";
import LaminatesPage from "./features/packaging/laminates/LaminatesPage";

import { Box } from "@mui/material";
import SchemaManagementPage from "./pages/admin/SchemaManagementPage";
import SchemaManagementV2Page from "./pages/admin/SchemaManagementV2Page";
import SchemaManagementV3Page from "./pages/admin/SchemaManagementV3Page";
import ConstraintsMasterPage from "./pages/admin/ConstraintsMasterPage";
import ApiRunLogsPage from "./pages/admin/ApiRunLogsPage";
import AppWorkspacePage from "./pages/admin/AppWorkspacePage";
import UserAccessManagementPage from "./pages/admin/UserAccessManagementPage";
import AnalysisPage from "./pages/admin/AnalysisPage";
import TracePage from "./pages/admin/TracePage";
import CalculationResultsPage from "./pages/results/CalculationResultsPage";
import ProtectedRoute from "./components/ProtectedRoute";
import { useAuth } from "./context/AuthContext";

// Component to handle mechanical costing page routing based on commodity
function MechanicalCostingPage() {
  const [searchParams] = useSearchParams();
  const commodity = searchParams.get("commodity");
  const isAI = searchParams.get("ai") === "true";

  // If commodity is "Plastics" with AI flag, use the regular PlasticsPage
  if (commodity === "Plastics" && isAI) {
    return <GenericPlasticsCosting />;
  }

  // If commodity is "Plastics" without AI flag, use the PlasticsPage from "plastics - Copy" folder
  if (commodity === "Plastics") {
    return <PlasticsPageCopy />;
  }

  // Default to regular PlasticsPage for other commodities
  return <GenericPlasticsCosting />;
}

// Component to handle sheetmetal page routing based on AI flag
function SheetmetalRouteHandler() {
  const [searchParams] = useSearchParams();
  const isAI = searchParams.get("ai") === "true";

  // If AI flag is set, use the regular version
  if (isAI) {
    return <SheetmetalPage />;
  }

  // Default to copy version (for regular Sheet Metal card)
  return <SheetmetalPageCopy />;
}

function App() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return null; // Or a loading spinner
  }

  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        overflow: "auto",
        background: "#191A1B",
      }}
    >
      <Routes>
        {/* Public route */}
        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to="/" replace /> : <LoginPage />}
        />

        {/* Protected routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <HomePage />
            </ProtectedRoute>
          }
        />

        {/* Tower commodity selection pages */}
        <Route
          path="/mechanical"
          element={
            <ProtectedRoute>
              <CommoditySelectionPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/electronics"
          element={
            <ProtectedRoute>
              <CommoditySelectionPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/packaging"
          element={
            <ProtectedRoute>
              <CommoditySelectionPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/bpch"
          element={
            <ProtectedRoute>
              <CommoditySelectionPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/fnb"
          element={
            <ProtectedRoute>
              <CommoditySelectionPage />
            </ProtectedRoute>
          }
        />

        {/* Tower costing pages */}
        <Route
          path="/mechanical/costing"
          element={
            <ProtectedRoute>
              <MechanicalCostingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/mechanical/sheetmetal"
          element={
            <ProtectedRoute>
              <SheetmetalRouteHandler />
            </ProtectedRoute>
          }
        />
        <Route
          path="/mechanical/casting"
          element={
            <ProtectedRoute>
              <CastingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/mechanical/forging"
          element={
            <ProtectedRoute>
              <ForgingPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/bpch/costing"
          element={
            <ProtectedRoute>
              <ShampooPage />
            </ProtectedRoute>
          }
        />

        {/* Generic costing routes */}
        <Route
          path="/fnb/generic"
          element={
            <ProtectedRoute>
              <GenericCostingPage2 />
            </ProtectedRoute>
          }
        />
        <Route
          path="/bpch/generic"
          element={
            <ProtectedRoute>
              <GenericCostingPage2 />
            </ProtectedRoute>
          }
        />
        <Route
          path="/test/form-fb"
          element={
            <ProtectedRoute>
              <GenericCostingPage2 />
            </ProtectedRoute>
          }
        />
        <Route
          path="/test/form-mech/plastics"
          element={
            <ProtectedRoute>
              <GenericPlasticsCosting />
            </ProtectedRoute>
          }
        />

        <Route
          path="/electronics/costing"
          element={
            <ProtectedRoute>
              <PCBPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/packaging/costing"
          element={
            <ProtectedRoute>
              <CorrugatedPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/packaging/laminates"
          element={
            <ProtectedRoute>
              <LaminatesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/packaging/glassbottles"
          element={
            <ProtectedRoute>
              <GlassbottlesPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/fnb/costing"
          element={
            <ProtectedRoute>
              <CookiesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/bpch/shampoo"
          element={
            <ProtectedRoute>
              <ShampooPage />
            </ProtectedRoute>
          }
        />
        {/* <Route
          path="/fnb/costing-old"
          element={
            <ProtectedRoute>
              <Form_FB />
            </ProtectedRoute>
          }
        /> */}

        {/* Admin pages */}
        <Route
          path="/admin/schema-management"
          element={
            <ProtectedRoute>
              <SchemaManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/schema-management-v2"
          element={
            <ProtectedRoute>
              <SchemaManagementV2Page />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/schema-management-v3"
          element={
            <ProtectedRoute>
              <SchemaManagementV3Page />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/constraints-master"
          element={
            <ProtectedRoute>
              <ConstraintsMasterPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/api-run-logs"
          element={
            <ProtectedRoute>
              <ApiRunLogsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/app-workspace"
          element={
            <ProtectedRoute>
              <AppWorkspacePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/user-management"
          element={
            <ProtectedRoute>
              <UserAccessManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/analysis"
          element={
            <ProtectedRoute>
              <AnalysisPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/trace"
          element={
            <ProtectedRoute>
              <TracePage />
            </ProtectedRoute>
          }
        />
        <Route path="/admin/analysis-popup" element={<Navigate to="/admin/trace" replace />} />
        <Route
          path="/results"
          element={
            <ProtectedRoute>
              <CalculationResultsPage />
            </ProtectedRoute>
          }
        />

        {/* Catch all - redirect to login if not authenticated, home if authenticated */}
        <Route path="*" element={<Navigate to={isAuthenticated ? "/" : "/login"} replace />} />
      </Routes>
    </Box>
  );
}

export default App;
